import { ProspectoCab } from './../../../models/ProspectoCab';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, Injector } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { FiltrosProspecto } from '../../../models/FiltrosProspecto';
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesSimuladorAgregarDetalle } from 'app/models/messages';
import { PropuestaOperacionDetalle } from '../../../models/PropuestaOperacionDetalle';
import { LoginService } from 'app/services/login/login.service';
import { ProformaService } from 'app/services/operaciones/proforma/proforma.service';
import { PropuestaOperacionService } from '../../../services/operaciones/propuesta-operacion/propuesta-operacion.service';
import { ProspectosService } from '../../../services/operaciones/prospectos/prospectos.service';
import { LocalService } from '../../../services/storage/localService';
import moment from 'moment';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { SecurityService } from '../../../services/security/security.service';
import { environment } from 'environments/environment';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;

@Component({
  selector: 'app-nuevo-evaluacion-operacion',
  templateUrl: './nuevo-evaluacion-operacion.component.html',
  styleUrls: ['./nuevo-evaluacion-operacion.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesDates, MessagesSimuladorAgregarDetalle,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class NuevoEvaluacionOperacionComponent implements OnDestroy {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Prospectos=environment.LABEL_PROSPECTOS;
  Label_Prospecto=environment.LABEL_PROSPECTO;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  Id_Descuento=environment.ID_DESCUENTO;
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;
  varDiasMin;
  varDiasMax;
  loading: boolean = false;
  formTEM: FormGroup;
  documentosDetalle: any[] = [];
  propuestaOperacionDetalle: PropuestaOperacionDetalle[] = [];
  tipoServicioElement = this.Id_Factoring;
  prospectoFiltroAdq: any;
  datosDN: any;
  Date = new Date();
  DTOFiltrosProspectos: FiltrosProspecto = new FiltrosProspecto();
  prospectos: ProspectoCab[] = [];
  prospectoSeleccionado: any;
  checkedProspecto: boolean = false;
  formPropuestaOperacion: FormGroup;
  user: any;
  bodyActualizacionDocumentos: any[] = [];
  NRO_MAXIMO_DOC_NEGOCIABLES: number;
  contadorDoc: number = 0;
  totSumVNPP: number = 0.00;
  monedaSymbol: string;
  tipoComprobanteDetail: string;
  subLista: Subscription[] = [];
  subProspecto: Subscription = new Subscription();
  subRanking: Subscription = new Subscription();
  subDocNegociable: Subscription = new Subscription();
  subCrearPropOp: Subscription = new Subscription();
  subEstadoDocNeg: Subscription = new Subscription();

  proformaService: ProformaService;
  loginService: LoginService;
  localService: LocalService;
  prospectoService: ProspectosService;
  propuestaOperacionService: PropuestaOperacionService;
  securityService: SecurityService;

  constructor(
    private injector: Injector,
    private datepipe: DatePipe,
    private router: Router
  ) {    
    this.proformaService = this.injector.get<ProformaService>(ProformaService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.localService = this.injector.get<LocalService>(LocalService);
    this.prospectoService = this.injector.get<ProspectosService>(ProspectosService);
    this.propuestaOperacionService = this.injector.get<PropuestaOperacionService>(PropuestaOperacionService);
    this.securityService = this.injector.get<SecurityService>(SecurityService);

    this.varDiasMin = this.localService.getJsonValue('ParametroRechazoMin');
    this.varDiasMax = this.localService.getJsonValue('ParametroRechazoMax');

    try {
      this.DTOFiltrosProspectos.FechaIni = this.datepipe.transform(moment().add(-30, 'day'), 'yyyy-MM-dd');
      this.DTOFiltrosProspectos.FechaFin = this.datepipe.transform(moment(), 'yyyy-MM-dd');
      this.datosDN = this.proformaService.datosProforma;
      this.validarProvAdq(this.datosDN.Num_Doc_Identificacion_Prov, this.datosDN.Num_Doc_Identificacion_Adq);
      
      if (this.datosDN.TipoMoneda == this.Label_id_soles) {
        this.monedaSymbol = 'S/ ';
      } else if (this.datosDN.TipoMoneda == this.Label_id_dolares) {
        this.monedaSymbol = '$ ';
      } else {
        this.monedaSymbol = '€ ';
      }

      if (this.datosDN.Tipo_Comprobante == 'F') {
        this.tipoComprobanteDetail = 'FACTURA';
      } else if (this.datosDN.Tipo_Comprobante == 'R') {
        this.tipoComprobanteDetail = 'RECIBO POR HONORARIOS';
      } else {
        this.tipoComprobanteDetail = 'LETRA';
      }
      
      this.obtenerProspectos();
      this.ObtenerDocumentosNegociables();
      this.ObtenerRanking();
    } catch (error) {
      this.loginService.clickGuard = true;
      this.router.navigate(['/operaciones/proformas/listado']);
    }

    let now = moment();
    this.formTEM = new FormGroup({
      'Plazo': new FormControl(''),
      'VNPP': new FormControl(''),
      'NombreComercialProv': new FormControl(this.datosDN.NombreComercialProv),
      'NombreComercialAdq': new FormControl(this.datosDN.NombreComercialAdq),
      'ProveedorScore': new FormControl(this.datosDN.ScoringProv),
      'AdquirenteScore': new FormControl(this.datosDN.ScoringAdq),
      'Num_Doc_Identificacion_Prov': new FormControl(this.datosDN.Num_Doc_Identificacion_Prov),
      'Num_Doc_Identificacion_ADQ': new FormControl(this.datosDN.Num_Doc_Identificacion_Adq),
      'ValorTipoCambio': new FormControl(3.33),
      'TipoCambio': new FormControl(this.datosDN.TipoCambio),
      'Moneda_Dsc': new FormControl(this.datosDN.Moneda_Dsc),
      'Adelanto_Porcentaje': new FormControl(90, [Validators.required, Validators.pattern('^[0-9.]+$')]),
      'Tipo_Comprobante': new FormControl(this.tipoComprobanteDetail),
      'Fecha_Desembolso': new FormControl(now),
      'Ranking': new FormControl(''),
      'Interes_Adquirente': new FormControl(0, [Validators.pattern('^[0-9.]+$')]),
      'Tipo_Servicio': new FormControl(this.Id_Factoring, [Validators.required]),
      'Importe_Adquirente': new FormControl(0)
    });

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.securityService.ObtenerParametros(this.user.id_empresa).subscribe(
      (res: any) => {
        let arrayTemp: any[] = res;
        for (let i = 0; i < arrayTemp.length; i++) {
          const el = res[i];
          if (el.Codigo == 'NRO_MAXIMO_DOC_PROPUESTA_OPERACION') {
            this.NRO_MAXIMO_DOC_NEGOCIABLES = el.Valor;
          }
        }
      },
      err => {
        this.NRO_MAXIMO_DOC_NEGOCIABLES = 10;
      }
    );

    this.formPropuestaOperacion = new FormGroup({
      idProspecto: new FormControl(''),
      Monto_Riesgo_Disponible: new FormControl(''),
      Num_Doc_Identificacion_Prov: new FormControl(this.formTEM.get('Num_Doc_Identificacion_Prov').value, [Validators.required]),
      Num_Doc_Identificacion_ADQ: new FormControl(this.formTEM.get('Num_Doc_Identificacion_ADQ').value, [Validators.required]),
      Ranking_Adq: new FormControl(''),
      Tipo_Servicio: new FormControl(this.formTEM.get('Tipo_Servicio').value, [Validators.required]),
      Tipo_Documento: new FormControl(this.formTEM.get('Tipo_Comprobante').value, [Validators.required]),
      Moneda: new FormControl(this.formTEM.get('Moneda_Dsc').value == 'DOLARES' ? this.Label_id_dolares : this.Label_id_soles, [Validators.required]),
      R_Social_Prov: new FormControl(this.formTEM.get('NombreComercialProv').value, [Validators.required]),
      R_Social_Adq: new FormControl(this.formTEM.get('NombreComercialAdq').value, [Validators.required]),
      Estado: new FormControl('P'),
      Alta_Usuario_Comercial: new FormControl(this.user.Usuario, [Validators.required]),
      Nombre_Usuario_Comercial: new FormControl(this.user.Nombre, [Validators.required]),
      Email_Usuario_Comercial: new FormControl(this.user.Email, [Validators.required]),
      Observaciones_Propuesta: new FormControl(''),
      PropuestaOperacionDetalle: new FormControl('')
    });

  }

  ngOnDestroy() {
    this.subLista.forEach(sub => { sub.unsubscribe(); });
  }

  obtenerProspectos() {
    this.DTOFiltrosProspectos.Estado = "";
    this.DTOFiltrosProspectos.FechaIni = this.datepipe.transform(this.DTOFiltrosProspectos.FechaIni, 'yyyy-MM-dd');
    this.DTOFiltrosProspectos.FechaFin = this.datepipe.transform(this.DTOFiltrosProspectos.FechaFin, 'yyyy-MM-dd');
    this.DTOFiltrosProspectos.Version = 2;
    this.subProspecto = this.prospectoService.obtenerProspectoCab(this.DTOFiltrosProspectos).subscribe(
      (res: any) => {
        this.prospectos = res;
        this.prospectoFiltroAdq = this.prospectos.filter(p => this.isProspectoValido(p));
        if (this.prospectos.length == 0 || this.prospectoFiltroAdq.length == 0) {
          this.showNotification('warning', 'top', 'right', 'No hay '+this.Label_Prospectos.toLowerCase()+' válidos para esta propuesta de operación.');
        }
      },
      (err: HttpErrorResponse) => {
        Swal.fire({
          title: "Ha ocurrido un error",
          text: err.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subProspecto);
  }

  isProspectoValido(p: ProspectoCab) {
    return (p.Ruc_Adquirente == this.datosDN.Num_Doc_Identificacion_Adq &&
      p.Ruc_Proveedor == this.datosDN.Num_Doc_Identificacion_Prov &&
      p.Moneda_Dsc == this.datosDN.Moneda_Dsc) &&
      ((p.idPropuestaOperacion == null && p.Monto_Riesgo_Disponible == 0) || (p.idPropuestaOperacion != null && p.Monto_Riesgo_Disponible > 0)) &&
      (p.Estado == 'A' || p.Estado == 'AC' || p.Estado == 'S');
  }

  seleccionarProspecto(elementoSeleccionado, checked: boolean) {
    this.prospectoSeleccionado = checked ? elementoSeleccionado.idProspecto : null;
    this.formPropuestaOperacion.get('idProspecto').setValue(elementoSeleccionado.idProspecto);
    this.formPropuestaOperacion.get('Monto_Riesgo_Disponible').setValue(elementoSeleccionado.Monto_Riesgo_Disponible);
  }

  ObtenerRanking() {
    this.subRanking = this.proformaService.obtenerRanking(this.datosDN.Num_Doc_Identificacion_Adq).subscribe(
      res => {
        this.formTEM.controls['Ranking'].setValue(res);
        this.formPropuestaOperacion.controls['Ranking_Adq'].setValue(res);
      },
      err => {
        let error = "";
        error = err.error.error;
        this.showNotification('warning', 'top', 'right', 'Error al intentar obtener ranking. \n Error: ' + error);
      }
    );

    this.subLista.push(this.subRanking);
  }

  validarProvAdq(rucProv, rucAdq) {
    let proveedoresArr = [];
    let adquirentessArr = [];

    proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));

    for (let item of proveedoresArr) {
      if (item.Num_Doc_Identificacion == rucProv && item.Estado != "A") {
        Swal.fire({
          title: '¡Alto!',
          text: this.Label_Proveedor+' bloqueado, no puede continuar.',
          type: 'error',
          allowOutsideClick: false,
          heightAuto: false
        });
        this.loginService.clickGuard = true;
        this.router.navigate(["/operaciones/propuesta-operacion/documentos"]);
        this.ObtenerDocumentosNegociables();
        break;
      }
    }

    for (let item of adquirentessArr) {
      if (item.Num_Doc_Identificacion == rucAdq && item.Estado != "A") {
        Swal.fire({
          title: '¡Alto!',
          text: this.Label_Adquirente+' bloqueado, no puede continuar.',
          type: 'error',
          allowOutsideClick: false,
          heightAuto: false
        });
        this.loginService.clickGuard = true;
        this.router.navigate(["/operaciones/propuesta-operacion/documentos"]);
        this.ObtenerDocumentosNegociables();
        break;
      }
    }

  }

  ObtenerDocumentosNegociables() {
    let Datos: any = {
      Tipo_Comprobante: '',
      Moneda: 0,
      Num_Doc_IdentificacionProv: '',
      Num_Doc_IdentificacionADQ: '',
      Tipo_Operacion: 'PO'
    };
    Datos.Tipo_Comprobante = this.datosDN.Tipo_Comprobante;
    Datos.Moneda = this.datosDN.TipoMoneda;
    Datos.Num_Doc_IdentificacionProv = this.datosDN.Num_Doc_Identificacion_Prov;
    Datos.Num_Doc_IdentificacionADQ = this.datosDN.Num_Doc_Identificacion_Adq;
    this.subDocNegociable = this.proformaService.ObtenerDocumentosNegociables(Datos).subscribe(
      (res: any[]) => {
        console.log("~ res", res)
        res.forEach(doc => {
          console.log({ doc });
          this.documentosDetalle.push(doc);
          this.bodyActualizacionDocumentos.push({ "idComprobante": String(doc.idComprobante), "Estado": "E" });
          this.propuestaOperacionDetalle.push({ "idComprobante": doc.idComprobante, checked: false, "Estado": "A" });
        });
        console.log("this.documentosDetalle", this.documentosDetalle);
        console.log("this.bodyActualizacionDocumentos", this.bodyActualizacionDocumentos);
        console.log("this.propuestaOperacionDetalle", this.propuestaOperacionDetalle);

        this.elimarCalculosPorCambioFecha();
      }
    );

    this.subLista.push(this.subDocNegociable);
  }

  agregarDocumentoALista(doc: any) {
    this.propuestaOperacionDetalle.forEach(documento => {
      if (documento.idComprobante == doc.idComprobante) {
        documento.checked = !documento.checked;
        if (documento.checked) {
          this.contadorDoc++;
          this.totSumVNPP += Number(doc.VNPP);
        } else {
          this.contadorDoc--;
          this.totSumVNPP -= Number(doc.VNPP);
        }
      }
    })
  }

  tipoServicio(event) {
    this.formTEM.controls['Tipo_Servicio'].setValue(event);
    this.formPropuestaOperacion.controls['Tipo_Servicio'].setValue(event);
    if (this.formTEM.controls.Tipo_Servicio.value == this.Id_Factoring || this.formTEM.controls.Tipo_Servicio.value == this.Id_Descuento) {
      this.formTEM.controls['Interes_Adquirente'].setValue('0');
      this.formTEM.controls['Importe_Adquirente'].setValue('0');
    }
  }

  elimarCalculosPorCambioFecha() {
    for (const iterator of this.documentosDetalle) {
      let fecha = moment(iterator.Fecha_de_Pago);
      iterator.Plazo = this.diferenciaEntreDiasEnDias(fecha['_d'], this.formTEM.controls['Fecha_Desembolso'].value._d);
    }
  }

  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc1 - utc2) / this.MILISENGUNDOS_POR_DIA);
  }

  guardarPropuestaOperacion() {
    if (this.contadorDoc == 0) {
      Swal.fire({
        title: 'Atención',
        text: 'SELECCIONE POR LO MENOS 1 DOCUMENTO PARA LA PROPUESTA DE OPERACIÓN.',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
    } else if (this.contadorDoc > this.NRO_MAXIMO_DOC_NEGOCIABLES) {
      Swal.fire({
        title: 'Atención',
        text: 'MÁXIMO '.concat(this.NRO_MAXIMO_DOC_NEGOCIABLES.toString(), ' DOCUMENTOS NEGOCIABLES PERMITIDOS POR PROPUESTA DE OPERACIÓN.'),
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
    } else {
      let arrayDetalleFinal: any[] = [];
      this.propuestaOperacionDetalle.forEach(value => {
        if (value.checked) {
          arrayDetalleFinal.push({ "idComprobante": value.idComprobante, "Estado": "A" });
        }
      })
      this.formPropuestaOperacion.get('PropuestaOperacionDetalle').setValue(arrayDetalleFinal);
      Swal.fire({
        title: 'Espere',
        text: 'Guardando información',
        type: 'info',
        allowOutsideClick: false,
        heightAuto: false
      });
      Swal.showLoading();
      this.subCrearPropOp = this.propuestaOperacionService.CrearPropuestaOperacion(this.formPropuestaOperacion.getRawValue()).subscribe(
        resCrear => {
          Swal.fire({
            title: 'Registrado con éxito',
            type: 'success',
            allowOutsideClick: true,
            heightAuto: false
          });
          this.loginService.clickGuard = true;
          this.router.navigate(["/operaciones/propuesta-operacion/listado"]);
        },
        (errCrear: HttpErrorResponse) => {
          Swal.fire({
            title: "Ha ocurrido un error",
            text: errCrear.error.error,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
      );

      this.subLista.push(this.subCrearPropOp);
    }
  }

  showNotification(type, from, align, message) {
    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
